import { createStyles, makeStyles } from '@material-ui/styles';
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        input: {
            // Hide the native file input.
            display: 'none',
        },
        promptButtonIcon: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            marginRight: theme.spacing(1),
        },
    });
});
//# sourceMappingURL=FileUploaderListItem.styles.js.map